const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;

function isISODateString(value: unknown): value is string {
  return typeof value === 'string' && ISO_DATE_PATTERN.test(value);
}

export function reviveDates<T>(obj: T): T {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (isISODateString(obj)) {
    const date = new Date(obj);
    if (!isNaN(date.getTime())) {
      return date as unknown as T;
    }
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(reviveDates) as unknown as T;
  }

  if (typeof obj === 'object') {
    const result: Record<string, unknown> = {};
    for (const key of Object.keys(obj)) {
      result[key] = reviveDates((obj as Record<string, unknown>)[key]);
    }
    return result as T;
  }

  return obj;
}
